var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"buybox-filter"},[_c(_setup.HiddenHorizontalScrollbar,_vm._l((_setup.filterOptions),function({ value, label }){return _c('label',{key:value},[_c('button',{staticClass:"buybox-filter__label",class:{
					'buybox-filter__label--active': value === _vm.buyboxFilterType,
				},on:{"click":function($event){return _setup.handleFilterClick(value)}}},[_vm._v(" "+_vm._s(label)+" ")])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }